import React from 'react';
import PropTypes from 'prop-types';

const HeaderLink = (props) => {
  const { options } = props;
  if (options.hasLink) {
    return (
      <a
        className="row-header__link"
        href={options.URL}
        target={(options.targetBlank) ? '_blank' : ''}
      >
        {options.linkText}
      </a>
    );
  }
  return null;
};

/**
 * @group Titles
 * Header module for sections
 */

const RowHeader = (props) => {
  const { opts } = props;
  return (
    <h2 className="row-header">
      <div className="row-header__title">
        <span className="row-header__text" dangerouslySetInnerHTML={{ __html: opts.text }} />
        <HeaderLink options={opts.options} />
      </div>
    </h2>
  );
};

HeaderLink.propTypes = {
  options: PropTypes.shape({
    URL: PropTypes.string,
    targetBlank: PropTypes.bool,
    linkText: PropTypes.string,
    hasLink: PropTypes.bool
  }).isRequired
};

RowHeader.propTypes = {
  opts: PropTypes.shape({
    options: PropTypes.shape({
      URL: PropTypes.string,
      targetBlank: PropTypes.bool,
      linkText: PropTypes.string,
      hasLink: PropTypes.bool
    }),
    text: PropTypes.string,
  }).isRequired,
};

export default RowHeader;
